// extracted by mini-css-extract-plugin
export var assigneeBadge = "_lo-0";
export var assigneeDetails = "_lo-1";
export var assigneeInfo = "_lo-2";
export var dropdownContainer = "_lo-4";
export var dropdownImage = "_lo-5";
export var editAssigneeInfo = "_lo-3";
export var editAssigneeModalContainer = "_lo-6";
export var hidden = "_lo-8";
export var input = "_lo-7";